export interface LoginModel {
    Username: string;
    Password: string;
}

export enum OnboardingStatus {
    AwaitingEmailVerification = "AwaitingEmailVerification",
    AwaitingProfileCompletion = "AwaitingProfileCompletion",
    AwaitingApproval = "AwaitingApproval",
    Approved = "Approved",
    ApprovalRevoked = "ApprovalRevoked"
}